const ProfileSkeleton={
    card: {
        background: '#EEEEEE',
        borderRadius: '16px',
        padding: '0 12px 16px',
        marginBottom:'20px'
    },
    firstRow: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: '25px',
        height: '0px',
        minHeight: '0px'
    },
    selectBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    centerlize: {
        display: "flex",
        justifyContent: "center",
    }
}
export default ProfileSkeleton